import PropTypes from "prop-types";
import React, { useState } from "react";
import { withTranslation } from "react-i18next";
import { withStyles } from "@material-ui/core/styles";

import {
  Button,
  Checkbox,
  Dialog,
  DialogContent,
  DialogTitle,
  FormLabel,
  Typography,
} from "@material-ui/core";

const styles = () => ({
  buttons: {
    marginTop: "24px",
    display: "flex",
    justifyContent: "flex-end",
  },
  button: {
    marginLeft: "12px",
  },
});

export const PassiveHardwareModal = (props) => {

  const { 
    modalOpen,
    handleModalClose,
    selectedVehicles,
    installPassiveHardware,
    setLoading,
    t,
  } = props;

  const [seatChecked, setSeatChecked] = useState(false);
  const [basketChecked, setBasketChecked] = useState(false);
  const [turnSignalChecked, setTurnSignalChecked] = useState(false);

  const closeModal = () => {
    setSeatChecked(false);
    setBasketChecked(false);
    setTurnSignalChecked(false);
    handleModalClose();
  };

  const installHardware = async () => {
    closeModal();
    setLoading(true);
    const vehicleObjs = selectedVehicles.map(v => {
      const vehicleObj = { id: v };
      if (seatChecked) {
        vehicleObj.seat_installed = true;
      }
      if (basketChecked) {
        vehicleObj.basket_installed = true;
      }
      if (turnSignalChecked) {
        vehicleObj.turn_signals_installed = true;
      }
      return vehicleObj;
    });

    await installPassiveHardware(vehicleObjs);
    setLoading(false);
  };

  return (
    <Dialog
      open={modalOpen}
      onClose={handleModalClose}
      aria-labelledby="passive-hardware-modal"
      fullWidth
      maxWidth="sm"
      style={{ zIndex: 9010 }}
    >
      <DialogTitle>
       <div>{t("Ota.InstallPassiveHardware")}</div>
       <Typography>{selectedVehicles.length} {t("Ota.Vehicles")}</Typography>
      </DialogTitle>
      <DialogContent>
        <div>
          <Checkbox
            checked={seatChecked}
            onChange={() => setSeatChecked(!seatChecked)}
          />
          <FormLabel>{t("Ota.PassiveHardware.Seat")}</FormLabel>
        </div>
        <div>
          <Checkbox
            checked={basketChecked}
            onChange={() => setBasketChecked(!basketChecked)}
          />
          <FormLabel>{t("Ota.PassiveHardware.Basket")}</FormLabel>
        </div>
        <div>
          <Checkbox
            checked={turnSignalChecked}
            onChange={() => setTurnSignalChecked(!turnSignalChecked)}
          />
          <FormLabel>{t("Ota.PassiveHardware.TurnSignals")}</FormLabel>
        </div>
        <div className={props.classes.buttons}>
          <Button
            variant="outlined"
            onClick={closeModal}
          >
            {t("Ota.Modals.Close")}
          </Button>
          <Button
            variant="outlined"
            onClick={installHardware}
            className={props.classes.button}
            disabled={!seatChecked && !basketChecked && !turnSignalChecked}
          >
            {t("Ota.Modals.Apply")}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};

PassiveHardwareModal.propTypes = {
  t: PropTypes.func.isRequired,
  modalOpen: PropTypes.bool.isRequired,
  handleModalClose: PropTypes.func.isRequired,
  installPassiveHardware: PropTypes.func.isRequired,
  setLoading: PropTypes.func.isRequired,
  selectedVehicles: PropTypes.array.isRequired,
  classes: PropTypes.object.isRequired,
};

export default withTranslation("common")(withStyles(styles)(PassiveHardwareModal));
